<script setup>
import ApexChart from "vue3-apexcharts";
import { ref } from "vue";
import _uniqueId from "lodash/uniqueId";
import { watch } from "vue";

const props = defineProps({
    data: {
        type: Array,
        default: [],
    },
    name: String,
    color: String,
    group: String,
});

const options = ref({
    chart: {
        id: _uniqueId("apex-chart-"),
        group: props.group,
        type: "area",
        sparkline: {
            enabled: true,
        },
    },
    colors: [props.color],
    stroke: {
        curve: "straight",
    },
    fill: {
        opacity: 0.3,
    },
    yaxis: {
        min: 0,
    },
    xaxis: {
        type: "datetime",
    },
    tooltip: {
        x: {
            format: "MMMM yyyy",
        },
        y: {
            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                return "$" + value;
            },
            title: {
                formatter: function formatter(val) {
                    return "";
                },
            },
        },
        marker: {
            show: false,
        },
        theme: "dark",
    },
});

const series = ref([]);

watch(
    () => props.data,
    () => {
        series.value = [
            {
                data: props.data,
            },
        ];
    },
    { immediate: true }
);
</script>

<template>
    <ApexChart :options="options" :series="series" />
</template>
